/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_3_DescInputs */

const et_case_3_desc = /** @type {(inputs: Case_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereerisime D&D Design Centerile struktureeritud SEO abil 75 700+ näitamist ja 1770+ orgaanilist klikki. 2,3% CTR-i ja paranevate positsioonidega toob leht nüüd järjepidevalt sissetulevat liiklust – vähendades sõltuvust tasulisest reklaamist ja ehitades pikaajalist kliendikanalit.`)
};

const en_case_3_desc = /** @type {(inputs: Case_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated 75,700+ impressions and 1,770+ organic clicks for D&D Design Center through structured SEO. With a 2.3% CTR and improving rankings, the site now drives consistent inbound traffic - reducing reliance on paid ads and building a long-term acquisition channel.`)
};

/**
* | output |
* | --- |
* | "Generated 75,700+ impressions and 1,770+ organic clicks for D&D Design Center through structured SEO. With a 2.3% CTR and improving rankings, the site now dr..." |
*
* @param {Case_3_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_3_desc = /** @type {((inputs?: Case_3_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_3_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_3_desc(inputs)
	return en_case_3_desc(inputs)
});